import React from 'react';
import { Stack } from '@moda/om';
import { ProductListPageResultFragment } from '../../generated/types/ProductListPageResultFragment';
import { GuidePageQuery_displayPage as DisplayPage } from '../../generated/types/GuidePageQuery';
import { noop } from '../../lib/noop';
import { SortOption } from '../../constants';
import { SidebarLayout, Sidebar, Content } from '../SidebarLayout';
import { PageFilter, PageFilterClear } from '../PageFilter';
import { GridItemCount } from '../GridPeripherals/GridItemCount';
import { GridSortByDropdown } from '../GridPeripherals/GridSortByDropdown';
import { SalePercentageTags } from '../SalePercentageTags/SalePercentageTags';
import { PLPBreadcrumbs } from '../PLPBreadcrumbs';
import './ProductListingDesktop.scss';

interface ProductListingDesktopProps {
  availableSorts: SortOption[];
  currentSort: SortOption;
  headerText: string;
  onSortChanged: (sort: string) => void;
  queryResult?: ProductListPageResultFragment | null;
  displayPage?: DisplayPage | null;
}

export const ProductListingDesktop: React.FC<ProductListingDesktopProps> = ({
  children,
  currentSort,
  availableSorts,
  onSortChanged,
  headerText,
  queryResult,
  displayPage
}) => {
  return (
    <>
      <PLPBreadcrumbs />

      <h1 className="ProductListingDesktop__header">{headerText}</h1>
      <SalePercentageTags saleTags={queryResult?.saleTags || []} />
      <div className="ProductListingDesktop__actions">
        <GridItemCount count={queryResult?.totalItems || 0} />

        <GridSortByDropdown
          currentSort={currentSort}
          availableSorts={availableSorts}
          onSortByChange={option => onSortChanged(option)}
        />
      </div>
      <SidebarLayout>
        <Sidebar stickAt={150}>
          <PageFilter
            attributes={queryResult?.attributes || []}
            availability={queryResult?.availability || null}
            categoryTree={queryResult?.categoryTree || null}
            colors={queryResult?.filterColors || []}
            designers={queryResult?.designers || []}
            sizes={queryResult?.sizes || []}
            guideSubPages={displayPage?.guideSubPages || null}
            onClose={noop}
          />
        </Sidebar>
        <Content>
          <Stack space={3}>
            <PageFilterClear
              attributes={queryResult?.attributes || []}
              designers={queryResult?.designers || []}
              sizes={queryResult?.sizes || []}
            />
            {children}
          </Stack>
        </Content>
      </SidebarLayout>
    </>
  );
};
